import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { ScheduleActivity as ScheduleActivityComponent } from '../../components/schedule-activity';

export const ScheduleActivity = () => {
  const { t } = useTranslation('schedule-activity');

  return (
    <Page maxWidth={'100%'}>
      <Page.Header>
        <Page.Header.Breadcrumbs
          breadcrumbs={[
            {
              label: t('Calendar'),
              to: '/schedule/calendar',
            },
            {
              label: t('Schedule Activity'),
            },
          ]}
        />
        <Page.Header.Heading>
          <Page.Header.Title title={t('Schedule Activity')} />
          <Page.Header.Subtitle subtitle={t("A summary of the practice's history for scheduling.")} />
        </Page.Header.Heading>
      </Page.Header>
      <Page.Body>
        <ScheduleActivityComponent />
      </Page.Body>
    </Page>
  );
};
